import type { ERoleType } from '@/types/enums'

export function useAllowedForRole (role: ERoleType): boolean {
  const { user } = useAuthStore()

  return user?.role === role
}
